import { Component } from '@angular/core';
import { BaseDatatableCellComponent } from '../base-datatable-cell.component';

@Component({
  template: `
    <p class="font-semibold text-sm">{{ title }}</p>
    <span class="text-[#525252] text-xs">
      {{ capitionText }}
    </span>
  `,
})
export class TitleWithCaptionComponent extends BaseDatatableCellComponent {
  get title() {
    const field = this.colDef().field;
    return this.rowData()[field];
  }
  get capitionText() {
    const prefix = this.colDef().custonConfig?.['captionPrefix'] ?? '';
    const captionField = this.colDef().custonConfig?.['captionField'] ?? '';
    return (prefix ? prefix + ' ' : '') + this.rowData()[captionField];
  }
}
